var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BjPage", {
        ref: "BjPage",
        attrs: {
          "label-width": "80px",
          "query-params": _vm.queryParams,
          selection: _vm.selection,
          "col-span": _vm.colSpan,
          "get-action": _vm.queryApi,
          "before-reset-search": _vm.beforeResetSearch,
        },
        on: {
          handleSelectionChange: _vm.handleSelectionChange,
          showSetting: _vm.SortableTable.show,
          "header-dragend": _vm.SortableTable.handleHeaderDragend,
          afterFetchOriginalData: _vm.afterFetchOriginalData,
          "header-contextmenu": _vm.SortableTable.handleHeaderContextmenu,
        },
        scopedSlots: _vm._u([
          {
            key: "baseForm",
            fn: function () {
              return [
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("billingPage.zoneGroup"),
                          prop: "logisticsGroupName",
                        },
                      },
                      [
                        _c("BjInput", {
                          attrs: {
                            placeholder: _vm.$t("billingPage.zoneGroup"),
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.queryParams.logisticsGroupName,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.queryParams,
                                "logisticsGroupName",
                                $$v
                              )
                            },
                            expression: "queryParams.logisticsGroupName",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("billingPage.zoneGroupType"),
                          prop: "zoneGroupType",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            "option-list": _vm.ZONE_GROUP_TYPE_LIST,
                            placeholder: _vm.$t("billingPage.zoneGroupType"),
                          },
                          on: { change: _vm.handleQuery },
                          model: {
                            value: _vm.queryParams.zoneGroupType,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "zoneGroupType", $$v)
                            },
                            expression: "queryParams.zoneGroupType",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableOperation",
            fn: function () {
              return [
                _c(
                  "el-col",
                  [
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "permission",
                            rawName: "v-permission:USER-ONBOARDING-ADD",
                            arg: "USER-ONBOARDING-ADD",
                          },
                        ],
                        staticClass: "main-btn",
                        attrs: { type: "primary" },
                        on: { click: _vm.onAdd },
                      },
                      [_vm._v(_vm._s(_vm.$t("createText")))]
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableColumn",
            fn: function () {
              return [
                _vm._l(_vm.dropCols, function (col, index) {
                  return [
                    col.prop !== "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || false,
                            align: "center",
                            "class-name": "item",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    false
                                      ? void 0
                                      : col.prop === "logisticsGroupName"
                                      ? [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "link",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.goDetail(scope.row)
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(scope.row[col.prop])
                                              ),
                                            ]
                                          ),
                                          _c("BjCopyIcon", {
                                            attrs: {
                                              copy: scope.row[col.prop],
                                            },
                                          }),
                                        ]
                                      : col.prop === "zoneGroupType"
                                      ? [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.ZONE_GROUP_TYPE_LIST.bjGet(
                                                  scope.row.zoneGroupType
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("timeFilters")(
                                                scope.row[col.prop],
                                                scope.row[col.prop]
                                              )
                                            )
                                          ),
                                        ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                    col.prop === "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || "right",
                            align: "center",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (props) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "edit-btn",
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onEdit(props.row)
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.$t("editText")))]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "edit-btn",
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onCopy(props.row)
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.$t("copyText")))]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "delete-btn",
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onDelete(props.row)
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.$t("delText")))]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                  ]
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogVisible,
            width: "500px",
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.form,
                "status-icon": "",
                rules: _vm.rules,
                "label-position": "top",
                "label-width": "100px",
              },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("billingPage.zoneGroup"),
                    prop: "logisticsGroupName",
                  },
                },
                [
                  _c("BjInput", {
                    attrs: { placeholder: _vm.$t("billingPage.zoneGroup") },
                    model: {
                      value: _vm.form.logisticsGroupName,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "logisticsGroupName", $$v)
                      },
                      expression: "form.logisticsGroupName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("billingPage.zoneGroupType"),
                    prop: "zoneGroupType",
                  },
                },
                [
                  _c("BjSelectLov", {
                    attrs: {
                      "option-list": _vm.ZONE_GROUP_TYPE_LIST,
                      placeholder: _vm.$t("billingPage.zoneGroupType"),
                    },
                    model: {
                      value: _vm.form.zoneGroupType,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "zoneGroupType", $$v)
                      },
                      expression: "form.zoneGroupType",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.handleClose } }, [
                _vm._v(_vm._s(_vm.$t("cancelText"))),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.onConfirm()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("okText")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }